import styled from 'styled-components';
import Dropdown from 'monday-ui-react-core/dist/Dropdown';
import { useContext, useMemo } from 'react';
import { useSignFlow } from '../../../hooks/useSignFlow';
import { FileContext } from '../../../context/FileContext';

const StyledDropdownForPdfSwitch = styled(Dropdown)`
  width: 167px;
`;

const PdfSwitchContainer = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  @media only screen and (max-width: 768px) {
    display: none;
  }
`;

const PdfSwitchDropdown = ({ t }) => {
  const { activeFileId, signingFlowAttachedFiles, setActiveFile, scrollToTop } =
    useSignFlow();
  const { setActiveField } = useContext(FileContext);

  const pdfOptions = useMemo(() => {
    return (
      signingFlowAttachedFiles?.map((x) => {
        return {
          value: x.fileId,
          label: x.name,
        };
      }) || []
    );
  }, [signingFlowAttachedFiles]);

  const selectedPDF = () => {
    return pdfOptions.find((x) => x.value === activeFileId);
  };

  const selectedPDFIndex = () => {
    return pdfOptions.findIndex((x) => x.value === activeFileId) + 1;
  };

  const handleChange = (e) => {
    setActiveFile(e.value);
    scrollToTop();
    setActiveField(null);
  };

  return (
    <PdfSwitchContainer>
      {pdfOptions.length > 1 ? (
        <>
          {' '}
          {t('Signing file')} {selectedPDFIndex()} {t('of')} {pdfOptions.length}
          <StyledDropdownForPdfSwitch
            clearable={false}
            searchable={false}
            options={pdfOptions}
            value={selectedPDF()}
            placeholder={t('PDF Name')}
            size={Dropdown.size.SMALL}
            className="dropdown-stories-styles_with-chips"
            onChange={handleChange}
          />
        </>
      ) : null}
    </PdfSwitchContainer>
  );
};

export default PdfSwitchDropdown;
